import { ModuleResource } from 'dashboard/modules/Resource';

export interface ModuleResourceInquiry extends ModuleResource {
  'field-key': 'inquiries';
  attributes: ResourceInquiryAttribute[];
  'inquiry-template'?: string | null;
  'hide-empty-attributes'?: boolean;
}

export enum ResourceInquiryAttribute {
  Address = 'address',
  BirthDate = 'birth_date',
  DocumentExtraction = 'document_extractions',
  EmailAddress = 'email_address',
  ExpirationDate = 'expiration_date',
  Fields = 'fields',
  GovernmentIDNumber = 'government_id_number',
  Name = 'name',
  PhoneNumber = 'phone_number',
  Photos = 'photos',
  ReviewerComment = 'reviewer_comment',
  SessionLocation = 'session_location',
  SocialSecurityNumber = 'ssn',
  Tags = 'tags',
}
